export default __webpack_public_path__ + "static/media/inactive.088e2ea0.svg";